import { Menu } from '@mui/material';
import { ReactNode } from 'react';

interface ConsoleMenuProps {
    readonly anchorEl: HTMLElement | null;
    readonly open: boolean;
    readonly onClose: () => void;
    /** Narrowest the panel is drawn; a long row still widens it. */
    readonly minWidth?: number;
    /**
     * Which edge of the trigger the panel grows from. A trigger near the
     * end of a bar opens from its right edge, so the panel runs back over
     * the bar rather than out over what follows the trigger.
     */
    readonly align?: 'left' | 'right';
    readonly children: ReactNode;
}

/**
 * A menu opening upward from a footer or bottom bar.
 *
 * Only the direction is its own: everything about how the panel and its rows
 * look comes from the theme, so a menu over the console reads as one of the
 * app's menus rather than a surface of its own.
 */
export default function ConsoleMenu({
    anchorEl,
    open,
    onClose,
    minWidth = 224,
    align = 'left',
    children,
}: ConsoleMenuProps) {
    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={{ vertical: 'top', horizontal: align }}
            transformOrigin={{ vertical: 'bottom', horizontal: align }}
            // The popover pins the paper's top edge, so a bottom margin
            // cannot part it from the trigger: the app's gap below a menu
            // becomes a negative top margin above this one.
            slotProps={{ paper: { sx: { minWidth, mt: -0.5 } } }}
        >
            {children}
        </Menu>
    );
}
